import { getLoanTermOptions, CUSTOM_TERM_KEY } from '../LoanFunctions';
import { LoanType } from '../LoanConstants';
import { Dispatch, SetStateAction } from 'react';

const styles = {
    formColumn: { paddingBottom: '3px' },
    customTermColumn: { paddingBottom: '3px', minWidth: '100px' },
};

interface LoanTermFieldsProps {
    loanTypeId: LoanType;
    selectedTermKey: string;
    set_selectedTermKey: (key: string) => void;
    initialTermMonths: number | null;
    set_initialTermMonths: Dispatch<SetStateAction<null>>;
    contractualExtension1Months: number | null;
    set_contractualExtension1Months: Dispatch<SetStateAction<null>>;
    contractualExtension2Months: number | null;
    set_contractualExtension2Months: Dispatch<SetStateAction<null>>;
    noteDate: Date | null;
    termDisabled?: boolean;
}

export const LoanTermFields = ({
    loanTypeId,
    selectedTermKey,
    set_selectedTermKey,
    initialTermMonths,
    set_initialTermMonths,
    contractualExtension1Months,
    set_contractualExtension1Months,
    contractualExtension2Months,
    set_contractualExtension2Months,
    noteDate,
    termDisabled = false,
}: LoanTermFieldsProps) => {
    return (
        <>
            <div
                className='columns small-12 large-2'
                style={styles.formColumn}
            >
                <label
                    htmlFor='selectedTermKey'
                    style={{ whiteSpace: 'nowrap' }}
                >
                    Term {noteDate && <span className='req'>*</span>}
                </label>
                <select
                    id='selectedTermKey'
                    value={selectedTermKey}
                    onChange={(event) => {
                        const key = event.target.value;
                        set_selectedTermKey(key);
                        if (key && key !== CUSTOM_TERM_KEY) {
                            const option = getLoanTermOptions(loanTypeId).find(o => o.key === key);
                            if (option) {
                                set_initialTermMonths(option.initialTermMonths);
                                set_contractualExtension1Months(option.contractualExtension1Months);
                                set_contractualExtension2Months(option.contractualExtension2Months);
                            }
                        } else if (key === CUSTOM_TERM_KEY) {
                            set_initialTermMonths(null);
                            set_contractualExtension1Months(null);
                            set_contractualExtension2Months(null);
                        }
                    }}
                    required={!!noteDate}
                    disabled={termDisabled}
                >
                    <option value=''></option>
                    {getLoanTermOptions(loanTypeId).map((opt) => {
                        return (
                            <option
                                key={opt.key}
                                value={opt.key}
                            >
                                {opt.name}
                            </option>
                        );
                    })}
                </select>
            </div>
            {selectedTermKey === CUSTOM_TERM_KEY && (
                <>
                    <div
                        className='columns small-12 large-1'
                        style={styles.customTermColumn}
                    >
                        <label htmlFor='initialTermMonths' style={{ whiteSpace: 'nowrap' }}>
                            Init. (mo.) {noteDate && <span className='req'>*</span>}
                        </label>
                        <input
                            type='number'
                            id='initialTermMonths'
                            value={initialTermMonths ?? ''}
                            onChange={(e) => set_initialTermMonths(e.target.value ? parseInt(e.target.value) : null)}
                            required={!!noteDate}
                            min={1}
                            max={999}
                        />
                    </div>
                    <div
                        className='columns small-12 large-1'
                        style={styles.customTermColumn}
                    >
                        <label htmlFor='contractualExtension1Months' style={{ whiteSpace: 'nowrap' }}>
                            Ext. 1 (mo)
                        </label>
                        <input
                            type='number'
                            id='contractualExtension1Months'
                            value={contractualExtension1Months ?? ''}
                            onChange={(e) => set_contractualExtension1Months(e.target.value ? parseInt(e.target.value) : null)}
                            min={0}
                            max={999}
                        />
                    </div>
                    <div
                        className='columns small-12 large-1'
                        style={styles.customTermColumn}
                    >
                        <label htmlFor='contractualExtension2Months' style={{ whiteSpace: 'nowrap' }}>
                            Ext. 2 (mo)
                        </label>
                        <input
                            type='number'
                            id='contractualExtension2Months'
                            value={contractualExtension2Months ?? ''}
                            onChange={(e) => set_contractualExtension2Months(e.target.value ? parseInt(e.target.value) : null)}
                            min={0}
                            max={999}
                        />
                    </div>
                </>
            )}
        </>
    );
};
